export default __webpack_public_path__ + "static/media/non.72a527ed.jpg";